import lf from 'lovefield'

export function const_parametresmateriels (schemaBuilder) {
  schemaBuilder.createTable('const_parametresmateriels')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('ordre', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('unite', lf.Type.STRING)
      .addColumn('type', lf.Type.STRING)
      .addColumn('standard', lf.Type.INTEGER)
      .addPrimaryKey(['id'])
      // .addUnique('code', ['code'])
}


/*
CREATE TABLE IF NOT EXISTS `const-parametresmateriels` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(4) NOT NULL,
  `ordre` tinyint(4) NOT NULL,
  `nom` varchar(50) NOT NULL,
  `unite` varchar(15) NOT NULL,
  `type` varchar(4) NOT NULL,
  `standard` tinyint(4) NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=28 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constParametresmateriels.schema.js